<template>
    <div class="main" style="padding-bottom: 50px; ">
        <div class="header-slideshow" :style="{backgroundImage: `url('${require('../assets/stock/storefront.jpg')}')`}"></div>
        <div class="deals">
            <h1 class="header-text"><i>WHAT WE OFFER</i></h1>
            <carousel class="carousel" :perPage="1" :perPageCustom="[[768, 3]]" :autoplay="true" :loop="true" :autoplayTimeout="3500">
                <slide v-for="(category, index) in productCategories" :key="index">
                    <div class="card" @click="$router.push('/products')">
                        <div class="image-container" :style="{backgroundImage: `url('${require('../assets/categories/' + category + '.jpg')}')`}"></div>
                        <h3>{{ category }}</h3>
                    </div>
                </slide>
            </carousel>
        </div>
        <div class="subsection">
			<span>
				“Favorite place to buy my Vape products, now the only 
                place I shop because their quality of products are worth 
                a 5 star review and their customer service is superb!”
                <br/> 
                -Jesse
				<br/>
				<br/>
				“This will always be the best go to shop for all your vape needs. 
                Really make you feel welcome and apart of their family!”
                <br/> 
                -Ashallee
			</span>
		</div>

        <div class="touple">
            <div 
                class="card" 
                @click="$router.push('/flavors')" 
                :style="{backgroundImage: `url('${require('../assets/stock/flavorsblur.jpg')}')`}"
            >
                <h3>Flavors</h3>
            </div>
            <div 
                class="card" 
                @click="$router.push('/products')" 
                :style="{backgroundImage: `url('${require('../assets/stock/productsblur.jpg')}')`}"
            >
                <h3>Products</h3>
            </div>
        </div>

        <div class="touple solo">
            <div 
                class="card" 
                @click="$router.push('/why-vape')" 
                :style="{backgroundImage: `url('${require('../assets/stock/switchblur.jpg')}')`}"
            >
                <h3>Make The Switch</h3>
            </div>
        </div>

        <div class="touple">
            <div 
                class="card" 
                @click="$router.push('/about#reviews')" 
                :style="{backgroundImage: `url('${require('../assets/stock/inner1blur.jpg')}')`}"
            >
                <h3>Testimonials</h3>
            </div>
            <div 
                class="card" 
                @click="$router.push('/about')" 
                :style="{backgroundImage: `url('${require('../assets/stock/inner2blur.jpg')}')`}"
            >
                <h3>Our Story</h3>
            </div>
        </div>
        <div class="spacer"></div>
        <h1 class="header-text"><i>WHAT WE DO</i></h1>
        <div class="info" style="width: 80%">
            <div class="about-card">
                <div class="image" :style="{ backgroundImage : `url('${require('../assets/stock/pricematch.jpg')}')` }"></div>
                <div class="content even">
                    <h1>Price Match Policy</h1>
                    We believe all our prices to be the best, but we will price match any retail store's price within 10 miles.
                    <br/>
                    <br/>
                </div>
            </div>

            <div class="about-card">
                <div class="image" :style="{ backgroundImage : `url('${require('../assets/stock/smok.png')}')` }"></div>
                <div class="content odd">
                    <h1>Last Pack Program</h1>
                    Our mission at Vape Queen is to give people the tools they need to 
                    break free from an addiction to cigarettes. Bring us your last pack 
                    of cigarettes in exchange for your first bottle of juice!
                </div>
            </div>
        </div>

        <div class="info" style="width: 80%">
            <div class="about-card">
                <div class="image" :style="{ backgroundImage : `url('${require('../assets/stock/delivery.jpg')}')` }"></div>
                <div class="content odd">
                    <h1>Delivery To Your Door</h1>
                    We offer delivery of our products for all orders over $10!
                    Delivery available within 5 miles.
                    <br/>
                    Call to order and for details!
                </div>
            </div>
            <div class="about-card">
                <div class="image" :style="{ backgroundImage : `url('${require('../assets/stock/shipping.jpg')}')` }"></div>
                <div class="content even">
                    <h1>Shipping In the U.S.</h1>
                    We offer shipping of any and all of our products throughout the contiguous United States.
                    <br/>
                    Call to order and for details!
                </div>
            </div>
        </div>

        <div class="spacer"></div>
        <div class="affiliates">
            <h1 class="header-text"><i>Proud Members Of</i></h1>
            <div class="images">
                <img @click="openLink('http://www.casaa.org')" src="../assets/affiliates/CASAA.png"/>
                <img @click="openLink('https://www.sfata.org')" src="../assets/affiliates/SFATA.jpeg"/>
                <img @click="openLink('http://notblowingsmoke.org')" src="../assets/affiliates/NBS.png"/>
            </div>
        </div>

        <div class="spacer"></div>
        <a href="https://www.instagram.com/vapequeen_/" target="_blank"><h1 class="header-text"><i>@VAPEQUEEN_</i></h1></a>
            <!-- <div class="arrow" :style="{backgroundImage: `url(${require('../assets/icons/arrow-left.png')})`}" style="height: 3rem; width: 3rem;" @click="decreaseIndex"></div> -->
            <carousel 
                :perPage="1" 
                :perPageCustom="[[0, 1], [768, 3], [1000, 4]]" 
                class="feed" 
                :navigationEnabled="true" 
                :navigationPrevLabel='`<img src="` + require(`../assets/icons/arrow-left.png`) + `" class="slider-previous">`'
                :navigationNextLabel='`<img src="` + require(`../assets/icons/arrow-right.png`) + `" class="slider-next">`'
                :navigationClickTargetSize="8"
                :paginationEnabled="false"
            >
                <slide v-for="image in feed" :key="image.id">
                    <div
                        class="instagram-card"
                        @click="openLink(image.link)"
                        :style="{backgroundImage: `url('${image.images.low_resolution.url}')`}">
                    </div>
                </slide>
            </carousel>
            <!-- <div class="arrow" :style="{backgroundImage: `url(${require('../assets/icons/arrow-right.png')})`}" style="height: 3rem; width: 3rem;" @click="decreaseIndex"></div> -->
            <div class="spacer"></div>
    </div>
</template>

<script>
import axios from 'axios'
import { Carousel, Slide } from 'vue-carousel'
export default {
    componenets: {
        Carousel,
        Slide
    },
    data() {
        return {
            feed: [],
            displayedSubsection: '',
            imageIndex: 0,
            productCategories: [
                'E-liquids',
                'CBD Products',
                'Kits',
                'Tanks',
                'Pocket Vapes',
                'Rebuildables',
                'Dry Herb',
                'Glass'
            ]
        }
    },
    async created() {
        this.feed = await axios.get('https://api.thevapequeen.com/instagram').then(x => x.data.data)
    },
    methods: {
        openLink(link) {
            window.open(link, '_blank')
        },
        calcSubsection(subsectionName) {
            console.log(subsectionName)
            if (this.displayedSubsection === subsectionName) this.displayedSubsection = ''
            else this.displayedSubsection = subsectionName
        },
        increaseIndex() {
            if (this.imageIndex < this.feed.length - 1) {
                this.imageIndex++
            } else {
                this.imageIndex = 0
            }
        },
        decreaseIndex() {
            if (this.imageIndex !== 0) {
                this.imageIndex--
            } else {
                this.imageIndex = this.feed.length - 1
            }
        },
        calcDisplayedImages(mobile) {
            let displayedImages = []
            let numToDisplay = mobile ? 1 : 4
            for (let i = 0; i < numToDisplay; ++i) {
                if (this.imageIndex + i > this.feed.length - 1)
                    displayedImages.push(this.feed[(this.imageIndex + i) - this.feed.length])
                else
                    displayedImages.push(this.feed[this.imageIndex + i])
            }
            return displayedImages
        }
    },
    computed: {
        webFeed() {
            return this.calcDisplayedImages(false)
        },
        mobileFeed() {
            return this.calcDisplayedImages(true)
        }
    }
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Nunito+Sans');

.VueCarousel-wrapper {
    padding-bottom: 10px;
}

.VueCarousel-navigation-button {
}

.info {
    width: 100% !important;
    .about-card {
        box-shadow: 0 4px 8px 0 rgba(0,0,0,0.5);
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 20px;
        width: 100%;
        height: 500px;
        font-family: 'Nunito Sans';
        font-weight: bold;
        text-align: center;
        h1 {
            font-family: 'Nunito Sans';
            font-weight: bold;
            font-size: 24px;
            margin-bottom: 10px;
        }
        .image { 
            width: 100%; 
            height: 100%;
        }
        .content {
            width: 100%;
            padding: 5%;
            &.even {
                background: #97d3ce;
            }
            &.odd {
                background: #d8c6e4;
            }
        }
        .image {
            background-size: cover; 
            background-position: center; 
            background-repeat: no-repeat;
        }
    }
}
.affiliates {
    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.5);
    width: 80%;
    border: 8px solid #d8c6e4;
    padding: 20px;
    .header-text {
        margin-top: 0;
    }
    .images {
        display: flex;
        justify-content: center;
        align-items: center;
        img {
            height: 100%;
            margin-left: 30px;
            margin-right: 30px;
            cursor: pointer;
        }
    }
}
.card {
    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.5);
}

.spacer {
    height: 80px;
    width: 100%;
}
.main {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.subsection {
	text-align: center;
    width: 100%;
    max-width: 1300px;
    background-image: linear-gradient(to left, #e5e5e5 17%, #ace4df 64%);
    padding: 4%;
    transition: all 0.5s ease;
    max-height: 5000px;
    font-family: Nunito Sans;
    margin: 20px;
    &.collapsed {
        max-height: 0;
        padding: 0;
        margin: 0;
        opacity: 0;
        span {
            opacity: 0;
        }
    }
}

.header-text {
    font-family: 'Allerta Stencil';
    margin-top: 30px;
    margin-bottom: 30px;
}

.slide-enter-active, .slide-leave-active {
  transition: all .5s ease;
}
.slide-enter, .slide-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.touple {
    color: white;
    margin-top: 20px;
    margin-bottom: 20px;
    width: 90%;
    max-width: 1200px;
    height: 340px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    &.solo {
        height: 500px;
    }
    .background {

    }
    .card {
        &:hover {
            cursor: pointer;
        }
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        font-family: Nunito Sans;
        font-size: 2em;
        position: relative;
        margin-left: 15px;
        margin-right: 15px;
        height: 100%;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
}

.instagram-card {
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    height: 15rem;
    width: 15rem;
    margin-left: 10px;
    margin-right: 10px;
    cursor: pointer;
}

.feed {
    width: 80%;
    max-width: 1366px;
}

.instagram {
    width: 100%;
    .arrow {
        width: 3rem;
        height: 3rem;
        &:hover {
            cursor: pointer;
        }
        background-position: center;
        background-repeat: no-repeat;
        background-size: contain;
    }
    .card {
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        height: 15rem;
        width: 15rem;
        margin-left: 10px;
        margin-right: 10px;
        cursor: pointer;
    }
}

.deals {
    width: 90%;
    // display: flex;
    // flex-direction: column;
    // align-items: center;
    // h1 {
        // padding: 5px;
    // }
}

.carousel {
    .image-container {
        height: 15rem;
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
    }
    .card {
        cursor: pointer;
        display: flex;
        flex-direction: column;
        font-family: 'Nunito Sans';
        text-align: center;
        margin-left: 10px;
        margin-right: 10px;
        h3 {
            margin-top: 10px;
            margin-bottom: 10px;
            font-style: bold;
        }
    }
}

.tryptic {
    display: flex;
    width: 100%;
    max-width: 1366px;
    flex-direction: row;
    justify-content: space-between;
    .image-container {
        height: 15rem;
        width: 100%;
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
    }
    .card {
        display: flex;
        flex-direction: column;
        width: 30%;
        font-family: 'Nunito Sans';
        text-align: center;
        margin-left: 10px;
        margin-right: 10px;
        h3 {
            margin-top: 10px;
            margin-bottom: 10px;
            font-style: bold;
        }
    }
}

.header-slideshow {
    z-index: -1;
    margin-top: -225px;
    width: 100%;
    height: 600px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
}

@media (max-width: 1300px) {
    .affiliates {
        .images {
            flex-wrap: wrap;
            img {
                margin-top: 20px;
            }
        }
    }
}

@media (min-width: 1030px) {
    .info {
        width: 90% !important;
        display: flex;
        flex-direction: row;
        .about-card {
            width: 100% !important;
            flex-direction: column !important;
            margin: 10px;
            .content {
                display: flex !important;
                align-items: center !important;
                justify-content: center !important;
                flex-direction: column !important;
                height: 400px !important;
                width: 100% !important;
                height: 30% !important;
                padding: 2% !important;
                &.odd {
                    order: 0;
                }
            }
            .image {
                height: 70% !important;
                width: 100% !important;
            }
        }
    }
}

@media (max-width: 827px) {
    .feed {
        width: 60%;
    }
    .affiliates {
        width: 100%;
    }
    .touple {
        flex-direction: column;
        width: 100%;
        margin-bottom: 10px;
        margin-top: 0;
        height: 600px;
        &.triple {
            height: 900px;
        }
        &.solo {
            height: 300px;
            margin-bottom: 0;
            .card {
                margin: 0;
                margin-bottom: 0;
            }
        }
        .card {
            margin-top: 10px;
            margin-left: 0;
        }
    }
    .deals {
        width: 100%;
    }
    .tryptic {
        .card {
            width: 100%;
            margin: 0;
        }
        flex-direction: column;
    }
}
</style>
